<template>
  <div>
  </div>
</template>

<script>
import sw from '@/utils/sweetAlert'

export default {
  mounted () {
    sessionStorage.clear()
    localStorage.removeItem('selectedUserId')
    localStorage.removeItem('selectedGroupId')
    history.pushState(null, null, location.href)
    window.addEventListener('popstate', () => {
      history.go(1)
    })
    sw.infoAlert('サインアウトしました。このタブを閉じてください')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/SignOut.vue